import { ACTIONS, can, canSee } from "./access";
import {
  RoleProfile,
  isClientUser,
  isDeveloper,
  isInternalLike,
  isManager,
  isPartnershipTeam,
  isPlatformAdmin,
  isRegularInternalUser,
  isSuperAdmin,
} from "./legacyRoles";

export type { RoleProfile };
export {
  isClientUser,
  isDeveloper,
  isInternalLike,
  isManager,
  isPartnershipTeam,
  isPlatformAdmin,
  isRegularInternalUser,
  isSuperAdmin,
};

export const canSeeIntegrations = (p: RoleProfile): boolean =>
  canSee(p, "integrations");

export const canSeeBotsManagement = (p: RoleProfile): boolean =>
  canSee(p, "bots_management");

// Automations has no read-only tier: whoever may open it may operate it,
// and only Client View makes it read-only.
export const isBotsOperator = canSeeBotsManagement;

// The notes beside the bot catalogue: whoever operates the bots edits them.
// Mirrors can_edit_bot_notes on the server.
export const canEditBotNotes = isBotsOperator;

// A client user whose "Integrations" is the Integration Platform instead of
// the legacy dashboard (CAL-5774): the Integration Dashboard role plus the
// platform experience, as the server decides it (integrations_platform.portal).
export const isClientPortalUser = (p: RoleProfile): boolean =>
  p?.user_type === "client" && can(p, ACTIONS.INTEGRATIONS_PLATFORM_PORTAL);

// Who may open the legacy /integrations* dashboard: anyone with the
// Integrations role whose experience is not the platform.
export const canOpenLegacyIntegrations = (p: RoleProfile): boolean =>
  canSeeIntegrations(p) && !isClientPortalUser(p);

// Where the sidebar "Integrations" entry and the Home tile lead.
export const integrationsHomePath = (p: RoleProfile): string =>
  isClientPortalUser(p) ? "/integrations-beta" : "/integrations";

export function roleLabel(p: RoleProfile): string {
  if (!p) return "";
  if (p.is_archived) return "Archived";
  if (p.access?.group) return p.access.group.name;
  if (p.user_type === "internal") return "No access group";
  return "Client User";
}
